import { Button } from 'antd';
import styled from 'styled-components';

export const ButtonWrapper = styled(Button)`
    border-color: #264758 !important;
    border-radius: 3px;

    display: flex;
    align-items: end;
    gap: 3px;

    span {
        font-family: 'DINNextLTPro';
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        color: #264758 !important;
    }

    &:hover {
        border-color: #264758;
    }
`;
